import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Client, Appointment, Exam, Sale, Orders, Invoice, Proforma, Dispense, Estimate, Insurance, Project, Note, Recall, Referral, Billing,  Document, ClientDataColumn } from 'helpers/ImportModels';
import { ClientMultiField as CMF } from 'constants/codes';
import { useSearchParams } from 'react-router-dom';
import { MediaList, ProfileUpload, useProfileImage, useSignatureImage } from 'helpers/ImageImports';
import { handleIntakeAll } from 'helpers/forms/ExamHelper';
import { User } from 'models/UserModel';

const ClientForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.CLIENT, Code.Form.Name.CLIENT];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, iframeRef2, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [cityOptions, setCityOptions] = Hooks.Form.Options();
  const [titleOptions, setTitleOptions] = Hooks.Form.Options();
  const [genderOptions, setGenderOptions] = Hooks.Form.Options();
  const [maritalOptions, setMaritalOptions] = Hooks.Form.Options();
  const [occupationOptions, setOccupationOptions] = Hooks.Form.Options();
  const [departmentOptions, setDepartmentOptions] = Hooks.Form.Options();
  const [doctorOptions, setDoctorOptions] = Hooks.Form.Options();
  const [medHistoryOptions, setMedHistoryOptions] = Hooks.Form.Options();
  const [yesNoOptions, setYesNoOptions] = Hooks.Form.Options();
  const [consentOptions, setConsentOptions] = Hooks.Form.Options();
  const [clientData, setClientData] = useState<ClientDataColumn>({});
  const [formData, setFormData] = useState<Client>({});
  const [medHistory, setMedHistory] = useState<string | undefined>(undefined);
  const [selectedConsent, setSelectedConsent] = useState<Number | undefined>(undefined);
  const [userData, setUserData] = useState<User | null>(null);
  const MedWidth = { condition:30, status: 10, Comment: 60 }

 const [fileList, setFileList] = useState<MediaList>({});
 const [profileUrl, setProfileUrl] = useState<string | null>(null);
 const {profileImage, handleProfileImageChange, handleAttachProfileImage, handleDeleteProfileImage } = useProfileImage(fileList, setFileList, setProfileUrl, setError);
  
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get(Code.UrlPara.Client);

  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  const RoleSpecial = Hooks.Privilege.RoleSpecial();
  Hooks.Privilege.HasOpen(Privilege);

  const doctorList = Utility.Convert.HashString(Utility.Storage.DoctorList());
  
  const [appointmentData, setAppointmentData] = useState<Appointment[]>([]);
  const appointmentWidth = { type: 12, date:10, start: 8, end: 8, doctor: 14, status: 12, postcheck:12, createdby: 12, comment: 12 }
  const PrivAppointment = Hooks.Privilege.List(Code.Form.Id.APPOINTMENT);

  const [examData, setExamData] = useState<Exam[]>([]);
  const examWidth = { date: 12, type:17, note: 30, doctor: 17, status:12, createdby: 12 }
  const PrivExam = Hooks.Privilege.List(Code.Form.Id.EXAM);

  const [saleData, setSaleData] = useState<Sale[]>([]);
  const saleWidth = { sno: 15, date: 15, desc: 55,  createdby: 15 }
  const PrivSale = Hooks.Privilege.List(Code.Form.Id.SALE);

  const [ordersData, setOrdersData] = useState<Orders[]>([]);
  const ordersWidth = { date: 12, sno:10, insurer: 12, net: 10, received: 10, balance: 10, segment:12, status:12, createdby: 12 }
  const PrivOrders = Hooks.Privilege.List(Code.Form.Id.ORDERS);
  
  const [invoiceData, setInvoiceData] = useState<Invoice[]>([]);
  const invoiceWidth = { date: 12, sno:10, insurer: 12, net: 10, received: 10, balance: 10, segment:12, status:12, createdby: 12 }
  const PrivInvoice = Hooks.Privilege.List(Code.Form.Id.INVOICE);

  const [proformaData, setProformaData] = useState<Proforma[]>([]);
  const proformaWidth = { date: 12, sno:10, Comment: 26, net: 10, segment:12, status:12, createdby: 12 }
  const PrivProforma = Hooks.Privilege.List(Code.Form.Id.PROFORMA);

  const [dispenseData, setDispenseData] = useState<Dispense[]>([]);
  const dispenseWidth = { date: 12, sno:10, Comment: 26, net: 10, segment:12, status:12, createdby: 12 }
  const PrivDispense = Hooks.Privilege.List(Code.Form.Id.DISPENSE);

  const [estimateData, setEstimateData] = useState<Estimate[]>([]);
  const estimateWidth = { date: 12, sno:10, Comment: 26, net: 10, segment:12, status:12, createdby: 12 }
  const PrivEstimate = Hooks.Privilege.List(Code.Form.Id.ESTIMATE);

  const [insuranceData, setInsuranceData] = useState<Insurance[]>([]);
  const insuranceWidth = { policy: 18, member: 18, group: 18,  insurer: 18, comment: 28 }
  const PrivInsurance = Hooks.Privilege.List(Code.Form.Id.INSURANCE);
  
  const [projectData, setProjectData] = useState<Project[]>([]);
  const projectWidth = { date: 12, sno:10, Comment: 36, type:12, status:12, createdby: 12 }
  const PrivProject = Hooks.Privilege.List(Code.Form.Id.PROJECT);

  const [noteData, setNoteData] = useState<Note[]>([]);
  const noteWidth = { date: 12, Comment: 46, type:12, status:12, createdby: 12 }
  const PrivNote = Hooks.Privilege.List(Code.Form.Id.NOTE);

  const [recallData, setRecallData] = useState<Recall[]>([]);
  const recallWidth = { type:12, Comment: 34, date: 12, segment:12,  status:12, createdby: 12 }
  const PrivRecall = Hooks.Privilege.List(Code.Form.Id.RECALL);

  const [referralData, setReferralData] = useState<Referral[]>([]);
  const referralWidth = { date: 12, Name: 30, doctor:20, recdoctor:20, createdby: 18 }
  const PrivReferral = Hooks.Privilege.List(Code.Form.Id.REFERRAL);

  const [billingData, setBillingData] = useState<Billing[]>([]);
  const billingWidth = { sno: 9, amount: 9, paid: 7, hsc:7, diag:7, status:9, doctor:9, createdby: 9, govtkey:9, billdate: 9, claimdate:9, remittancedate:9 }
  const PrivBilling = Hooks.Privilege.List(Code.Form.Id.BILLING);

  const [documentData, setDocumentData] = useState<Document[]>([]);
  const documentWidth = { date: 12, type:10, Comment: 43, fileno: 12, createdby: 15 }
  const PrivDocument = Hooks.Privilege.List(Code.Form.Id.DOCUMENT)
  const PriDocumentList = Hooks.Privilege.Document();

  const PrivCredit = Hooks.Privilege.List(Code.Form.Id.CREDIT);
  
  useEffect(() => {
    Files.Json.API(Code.File.CITY, Code.Option.Common.NA, setCityOptions, setError);
    Files.Json.API(Code.File.DOCTOR, Code.Option.Common.BLANK, setDoctorOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.MEDICAL_HISTORY, Code.Option.Common.NOTHING, setMedHistoryOptions, setError);
    Files.Json.Http(Code.File.DEPARTMENT, Code.Option.Common.BLANK, setDepartmentOptions, setError);
    Files.Json.Http(Code.File.TITLE, Code.Option.Common.BLANK, setTitleOptions, setError);
    Files.Json.Http(Code.File.GENDER, Code.Option.Common.BLANK, setGenderOptions, setError);
    Files.Json.Http(Code.File.MARITAL, Code.Option.Common.BLANK, setMaritalOptions, setError);
    Files.Json.Http(Code.File.OCCUPATION, Code.Option.Common.BLANK, setOccupationOptions, setError);
    Files.Json.Http(Code.File.YESNO, Code.Option.Common.BLANK, setYesNoOptions, setError);
    Files.Json.API(Code.File.CONSENT, Code.Option.Common.SELECT, setConsentOptions, setError);
   
    API.Data.GetByKeyId<Client>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.client_active); 
        setMedHistory(data.client_med_history);
        Files.List.ParseFile(data.file_list, setFileList);
        Files.List.ParseCommonData(data.client_data, setClientData);
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));

        if(keyId!==Code.Key.NEW) {
          if(PrivAppointment.ALL || PrivAppointment.VIEW) callAppointmentList(data.client_id);
          if(PrivExam.ALL || PrivExam.VIEW) callExamList(data.client_id);
          if(PrivSale.ALL || PrivSale.VIEW) callSaleList(data.client_id);
          if(PrivOrders.ALL || PrivOrders.VIEW) callOrdersList(data.client_id);
          if(PrivInvoice.ALL || PrivInvoice.VIEW) callInvoiceList(data.client_id);
          if(PrivProforma.ALL || PrivProforma.VIEW) callProformaList(data.client_id);
          if(PrivDispense.ALL || PrivDispense.VIEW) callDispenseList(data.client_id);
          if(PrivEstimate.ALL || PrivEstimate.VIEW) callEstimateList(data.client_id);
          if(PrivInsurance.ALL || PrivInsurance.VIEW) callInsuranceList(data.client_id);
          if(PrivProject.ALL || PrivProject.VIEW) callProjectList(data.client_id);
          if(PrivNote.ALL || PrivNote.VIEW) callNoteList(data.client_id);
          if(PrivRecall.ALL || PrivRecall.VIEW) callRecallList(data.client_id);
          if(PrivReferral.ALL || PrivReferral.VIEW) callReferralList(data.client_id);
          if(PrivBilling.ALL || PrivBilling.VIEW) callBillingList(data.client_id);
          if(PrivDocument.ALL || PrivDocument.VIEW) callDocumentList(data.client_id);
        }
        
        setUserData(await API.Data.GetUser(data.user_id));

        setLoading(false);
      }})


      const onNewEntry = async () => {
        if(keyId===Code.Key.NEW && clientId) {
          API.Data.GetByKeyId<Client>(formName, clientId, setLoading, setError)
            .then(async(data) => { if(data) {
              setFormData((prevData) => ({
                ...prevData,
                client_family_id: data.client_family_id,
                client_phone: data.client_phone,
                client_address: data.client_address,
                city_id: data.city_id,
                client_postal: data.client_postal,
              }));
            }});
        }
        setLoading(false);
      };
      onNewEntry()

  }, []);

  useEffect(() => {
    //console.log("dob: ", formData.client_dob); 
  }, [formData.client_dob]);

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    const addonData = await API.Data.AddonData(formData, formName, keyId);  
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
      client_first_name: Utility.Convert.TitleCase(formData.client_first_name),
      client_middle_name: Utility.Convert.TitleCase(formData.client_middle_name),
      client_last_name: Utility.Convert.TitleCase(formData.client_last_name),
      client_phone: Utility.Convert.Number(formData.client_phone),
      client_cell: Utility.Convert.Number(formData.client_cell),
      client_mobile: Utility.Convert.Number(formData.client_mobile),
      client_fax: Utility.Convert.Number(formData.client_fax),
      client_data: Utility.Clean.JsonObject(clientData),
      client_dob: Utility.Date.DateOrNull(formData.client_dob),
      client_med_history: medHistory,
      file_list: JSON.stringify(Files.List.Clean(fileList)),
    });

    ////console.log("Final Data to Save: ", finalData);
     API.Data.Save(formName, keyId, finalData, setMessage)
  };

  const sendWelcomeMessage = async () => {
    try {
      const clientId = formData.client_id || 0;
      const locationId = formData.location_id || 0; 
      const segmentId = Number(Code.Option.MessageSegment.PICKUP); 
    
      //console.log("Sending Pickup Message with Client ID:", clientId, "Location ID:", locationId, "Segment ID:", segmentId);

      if(clientId>0 && locationId>0 && segmentId>0) {  
        const response = await API.Data.sendMessage(formData.client_id, formData.location_id, Code.Option.MessageSegment.PICKUP, setMessage );
        //console.log(response);
      }
      
    } catch (error) {
      console.error(error);
    }
  };

  const callAppointmentList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.APPOINTMENT, 500, Name.Appointment.StartDate, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Appointment.Id,
        Name.Appointment.StartDate, 
        Name.Appointment.StartTime, 
        Name.Appointment.EndTime, 
        Name.Doctor.FullName, 
        Name.Common.TypeName, 
        Name.Common.StatusName, 
        Name.Common.StatusColor, 
        Name.Common.PostCheckName, 
        Name.User.FullName, 
        Name.Appointment.Comment,
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Appointment>(url, setAppointmentData, setError, setLoading);
   };

   const callExamList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.EXAM, 500, Name.Exam.Date, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Exam.Id,
        Name.Exam.Date, 
        Name.ExamType.Name,
        Name.Common.StatusName, 
        Name.Doctor.FullName,
        Name.User.FirstName,
        Name.Exam.Data2,
        Name.Exam.Data3
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Exam>(url, setExamData, setError, setLoading);
   };

   const callSaleList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.SALE, 500, Name.Sale.Date, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Sale.Id,
        Name.Sale.Date, 
        Name.Sale.Number, 
        Name.Sale.SaleOrderData, 
        Name.User.FirstName,
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Sale>(url, setSaleData, setError, setLoading);
   };

   const callOrdersList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.ORDERS, 500, Name.Orders.Date, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Orders.Id,
        Name.Orders.Date, 
        Name.Orders.Number, 
        Name.Common.insurer1Name, 
        Name.Segment.Name, 
        Name.Common.StatusName, 
        Name.Orders.Net,
        Name.User.FirstName,
        Name.Sale.Id,
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Orders>(url, setOrdersData, setError, setLoading);
   };

  const callInvoiceList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.INVOICE, 500, Name.Invoice.Date, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Invoice.Id,
        Name.Invoice.Date, 
        Name.Invoice.Number, 
        Name.Common.insurer1Name, 
        Name.Segment.Name, 
        Name.Common.StatusName, 
        Name.Invoice.Net,
        Name.User.FirstName,
        Name.Sale.Id,
      ]),
      [Name.Client.Id]: clientId,
      ...(RoleSpecial.includes(Code.RoleSpecial.DOCTOR_INVOICES) && { doctor_list: doctorList })
    });
    await API.Data.List<Invoice>(url, setInvoiceData, setError, setLoading);
   };

  const callProformaList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.PROFORMA, 500, Name.Proforma.Date, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Proforma.Id,
        Name.Proforma.Date, 
        Name.Proforma.Number, 
        Name.Proforma.Comment, 
        Name.Proforma.Net,
        Name.Segment.Name, 
        Name.Common.StatusName, 
        Name.User.FirstName,
        Name.Sale.Id,
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Proforma>(url, setProformaData, setError, setLoading);
   };

  const callDispenseList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.DISPENSE, 500, Name.Dispense.Date, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Dispense.Id,
        Name.Dispense.Date, 
        Name.Dispense.Number, 
        Name.Dispense.Comment, 
        Name.Dispense.Net,
        Name.Segment.Name, 
        Name.Common.StatusName, 
        Name.User.FirstName,
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Dispense>(url, setDispenseData, setError, setLoading);
   };

  const callEstimateList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.ESTIMATE, 500, Name.Estimate.Date, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Estimate.Id,
        Name.Estimate.Date, 
        Name.Estimate.Number, 
        Name.Estimate.Comment, 
        Name.Estimate.Net,
        Name.Segment.Name, 
        Name.Common.StatusName, 
        Name.User.FirstName,
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Estimate>(url, setEstimateData, setError, setLoading);
   };

  const callInsuranceList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.INSURANCE, 500, Name.Insurance.Id, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Insurance.Id,
        Name.Insurance.PolicyNumber, 
        Name.Insurance.memberNumber, 
        Name.Insurance.GroupNumber, 
        Name.Insurance.Comment, 
        Name.Insurer.Name,
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Insurance>(url, setInsuranceData, setError, setLoading);
   };

  const callProjectList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.PROJECT, 500, Name.Project.Id, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Project.Id,
        Name.Project.Date, 
        Name.Project.Number, 
        Name.Project.Comment, 
        Name.Common.TypeName, 
        Name.Common.StatusName, 
        Name.User.FirstName,
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Project>(url, setProjectData, setError, setLoading);
   };

  const callNoteList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.NOTE, 500, Name.Note.Date, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Note.Id,
        Name.Note.Date, 
        Name.Note.Comment, 
        Name.Common.TypeName, 
        Name.Common.StatusName, 
        Name.User.FirstName,
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Note>(url, setNoteData, setError, setLoading);
   };

  const callRecallList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.RECALL, 500, Name.Recall.Date, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Recall.Id,
        Name.Common.TypeName, 
        Name.Recall.Comment, 
        Name.Recall.Date, 
        Name.Segment.Name, 
        Name.Common.StatusName, 
        Name.User.FirstName,
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Recall>(url, setRecallData, setError, setLoading);
   };

   const callReferralList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.REFERRAL, 500, Name.Referral.Date, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Referral.Id, 
        Name.Referral.Date, 
        Name.Referral.Name,
        Name.Doctor.FullName, 
        Name.RecDoctor.FullName,
        Name.User.FirstName,
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Referral>(url, setReferralData, setError, setLoading);
   };


  const callBillingList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.BILLING, 500, Name.Billing.BillingDate, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Billing.Id, 
        Name.Billing.Number, 
        Name.Billing.Amount, 
        Name.Billing.InsuranceAmount, 
        Name.Billing.HscName,
        Name.Billing.Diagnosis1Name,
        Name.Common.StatusName, 
        Name.Doctor.FullName, 
        Name.User.FullName, 
        Name.Billing.GovKey, 
        Name.Billing.BillingDate, 
        Name.Billing.ClaimDate, 
        Name.Billing.RemittanceDate, 
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Billing>(url, setBillingData, setError, setLoading);
   };

  
  const callDocumentList = async (clientId: number | undefined) => {
    if (!clientId) return; 
    let documentList = '';
    if(PriDocumentList) documentList = PriDocumentList.replace(/^#|#$/g, "").replace("00000","").replaceAll("#", ","); 
    const url = API.Build.FormApiEndpint(Code.Form.Name.DOCUMENT, 500, Name.Document.Id, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Document.Id,
        Name.Document.Date, 
        Name.Common.TypeName, 
        Name.Document.Comment, 
        Name.Document.FileNo,
        Name.User.FirstName,
      ]),
      [Name.Client.Id]: clientId,
      ...(documentList != '' && { type_list: documentList })
    });
    await API.Data.List<Document>(url, setDocumentData, setError, setLoading);
   };

  const viewConsentForm = () => {
    if(selectedConsent){
      Form.Show.Popup(iframeRef, `${Code.Form.Name.CONSENT}/print/${selectedConsent}`, Code.UrlPara.Client, formData.client_id); 
    }
  };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} title={Utility.Get.ClientNameHtml(formData,Code.Format.Client.AGE_GENDER)} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} Privilege={Privilege}>
            <span className='fright pasteall mt-3' onClick={() => { handleIntakeAll(setFormData); handleIntakeAll(setClientData); }} title="Paste All Fields"></span>
            {keyId !== Code.Key.NEW && (<>
              <Button.Action title={'Show'} info={Info.AddProduct} onClick={viewConsentForm}  className='fright' />
              <Control.DropdownInline keyId={keyId} title={"Select document for consent form"} options={consentOptions} onChange={setSelectedConsent} className='fright' />
              <Control.Form.CheckList title='Options' className='fright'>
                {(Privilege.ALL || Privilege.VIEW) && (<Button.Action title={'View Family'} info={"View family"} onClick={() => Form.Show.Popup(iframeRef,`familylist/${formData.client_id}`)}  className='fright' animation={false} /> )}
                {(PrivCredit.ALL || PrivCredit.VIEW) && (<Button.Action title={'Wallet'} info={"View wallet"} onClick={() => Form.Show.Popup(iframeRef,`familycredit/${formData.client_id}`)}  className='fright' animation={false} /> )}
                {(Privilege.ALL || Privilege.CREATE) && (<Button.Action title={'+ Add Family'} info={"Add new member in this family"} onClick={() => Form.Show.Popup(iframeRef,`client/new`, Code.UrlPara.Client, formData.client_id)}  className='fright' animation={false} /> )}
                {Privilege.DELETE && (<Button.Action title={'Merge Patient'} info={"Merge same patient into this account"} onClick={() => Form.Show.Popup(iframeRef,`merge/${formData.client_key}`)}  className='fright' animation={false} /> )}
                {(Privilege.ALL || Privilege.VIEW) && (<Button.Action title={'Communication'} info={"View all communications"} onClick={() => Form.Show.Popup(iframeRef,`familycommunication/${formData.client_id}`)}  className='fright' animation={false} /> )}
              </Control.Form.CheckList>
            </>)}
          </Button.Save>
          <Control.Tab.HeaderSuper titles={[['Personal','0',''],['Medical','0',''],['Appointment', appointmentData.length.toString(),''],['Exam',examData.length.toString(),''],['Sale',saleData.length.toString(),''],['Order',ordersData.length.toString(),''],['Invoice',invoiceData.length.toString(),''],['Proforma',proformaData.length.toString(),''],['Dispense',dispenseData.length.toString(),''],['Estimate',estimateData.length.toString(),''],['Insurance', insuranceData.length.toString(),''],['Project',projectData.length.toString(),''],['Notes',noteData.length.toString(),''],['Recall',recallData.length.toString(),''],['Referral',referralData.length.toString(),''],['Billing',billingData.length.toString(),''],["Document",documentData.length.toString(),'']]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            
            <Control.Tab.Content title='Personal' id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Flex className='pt2'>
                <Control.Column size={[0,25,2,1]}>
                  <Control.Container>
                    <Field.ContainerTitle title='Basic Information' />
                    <Control.Box>
                      <Field.Text id={Name.Client.HealthCard} value={formData.client_health_card} title={Title.HealthCard} onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} maxLength={9} />
                      <Field.Select id={Name.Common.TitleId} value={formData.title_id} title={Title.Title} options={titleOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                      <Field.Text id={Name.Client.FirstName} value={formData.client_first_name} title={Title.FirstName} onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true} horizontal={true} />
                      <Field.Text id={Name.Client.MiddleName} value={formData.client_middle_name} title={Title.MiddleName} onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true}  />
                      <Field.Text id={Name.Client.LastName} value={formData.client_last_name} title={Title.LastName} onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                      <Field.Text id={Name.Client.PreferName} value={formData.client_prefer_name} title={Title.PreferName} onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                    </Control.Box>
                  </Control.Container>
                </Control.Column>
                <Control.Column size={[2,25,2,2]}>
                  <Control.Container >
                    <Field.ContainerTitle title='Other Information' />
                    <Control.Box>
                      <Field.Date id={Name.Client.Dob} value={formData.client_dob} title={Title.DateOfBirth} onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                      <Field.Select id={Name.Common.GenderId} value={formData.gender_id} title={Title.Gender} options={genderOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                      <Field.Select id={Name.Common.MaritalId} value={formData.marital_id} title={Title.Marital} options={maritalOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                      <Field.Select id={Name.Common.OccupationId} value={formData.occupation_id} title={Title.Occupation} options={occupationOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                      <Field.Text id={Name.Client.Referby} value={formData.client_referby} title={Title.refer} onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                      <Field.Select id={Name.Doctor.Id} value={formData.doctor_id} title={Title.Doctor} options={doctorOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                    </Control.Box>
                  </Control.Container>
                </Control.Column>
                <Control.Column size={[2,25,2,3]}>
                  <Control.Container>
                    <Field.ContainerTitle title='Contact Information' />
                    <Field.Text id={Name.Client.Phone} value={Utility.Format.Phone(formData.client_phone)} title={Title.Phone} onChange={(e) => Form.Field.Change(e, formData, setFormData)}  horizontal={true} require={true} />
                    <Field.Text id={Name.Client.Cell} value={Utility.Format.Phone(formData.client_cell)} title={Title.Cell} onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                    <Field.Text id={Name.Client.Mobile} value={Utility.Format.Phone(formData.client_mobile)} title={Title.Home} onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true}  />
                    <Field.Text id={Name.Client.Email} value={formData.client_email} title={Title.Email} onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                    <Field.Text id={Name.Client.Fax} value={Utility.Format.Phone(formData.client_fax)} title={Title.Fax} onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                    <Field.Text id={Name.Client.RefNo} value={formData.client_ref_number} title={Title.Refno} onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                  </Control.Container>
                </Control.Column>
                <Control.Column size={[2,25,0,4]}>
                  <Control.Container>
                    <Field.ContainerTitle title='Photo' className='mb2' />
                    <Control.Box className='bcf br'>
                      <ProfileUpload imageUrl={profileUrl} handleImageChange={handleProfileImageChange} handleAttachImage={handleAttachProfileImage} handleDeleteImage={handleDeleteProfileImage} summary={Info.ProfileSize} />
                    </Control.Box>
                  </Control.Container>
                </Control.Column>
              </Control.Flex>
              <Control.Flex>
                <Control.Column size={[0,25,2,1]}>
                  <Control.Container>
                    <Field.ContainerTitle title='Other Information' />
                    <Field.Select id={Name.Client.MedDeptId} value={formData.med_department_id} title="Third Party" options={departmentOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                    <Field.Text id={Name.Client.MedNo} value={formData.client_med_number} title="Third Party#" onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                    <Field.Text id={Name.Client.GiftCard} value={formData.gift_card_number} title={Title.GiftCard} onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                  </Control.Container>
                </Control.Column>
                <Control.Column size={[2,25,2,2]}>
                  <Control.Container>
                    <Field.ContainerTitle title='Home Address' />
                    <Field.Area id={Name.Client.Address} value={formData.client_address} onChange={(e) => Form.Field.Change(e, formData, setFormData)} height={76} controlClass='mt2' />
                    <Field.Select id={Name.City.Id} value={formData.city_id} title={Title.City} options={cityOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} />
                    <Field.Text id={Name.Client.Postal} value={formData.client_postal} title={Title.Postal} onChange={(e) => Form.Field.Change(e, formData, setFormData)} horizontal={true} className='ttu mb2' />
                  </Control.Container>
                </Control.Column>
                <Control.Column size={[2,25,2,3]}>
                  <Control.Container>
                    <Field.ContainerTitle title='Remarks' />
                    <Field.Area id={Name.Client.Comment} value={formData.client_comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} height={190} controlClass='mt2 alert' />
                  </Control.Container>
                </Control.Column>
                <Control.Column size={[2,25,0,4]}>
                  <Control.Container>
                    <Field.ContainerTitle title='Quick Info' className='mb2' />
                    <Control.Box>
                      <Field.Display title="Client Since" value={Utility.Format.DateOnly(formData.client_date)} />
                      <Field.Display title={Title.CreatedBy} value={userData?.user_first_name} />
                    </Control.Box>
                  </Control.Container>
                </Control.Column>
              </Control.Flex>
            </Control.Tab.Content>
            
            <Control.Tab.Content title='Medical' id={Code.Tab.Tab2} isActive={activeTab === Code.Tab.Tab2}>
              <Control.Row>
                <Control.Flex className='pt2'>
                  <Control.Column size={[0,70,2,1]}>
                    <Control.Box>
                      <Control.Container>
                        <Field.ContainerTitle title='Medical History' />
                        <Control.Box>
                          <Control.Form.Table>
                            <Control.Form.Title>
                              <Control.Form.Columns values={[
                                ["Condition", MedWidth.condition],
                                ["Status", MedWidth.status],
                                ["Remarks", MedWidth.Comment],
                              ]} />
                            </Control.Form.Title>
                            <Control.Form.List>
                              {medHistoryOptions.map((medhistory, index) => { return (
                                <Control.Form.Index key={index} index={index}>
                                  <Control.Form.Item>
                                    <Control.Form.Text id={`C${medhistory.value}`} value={medhistory.label} size={[MedWidth.condition]} disabled={true} />
                                    <Control.Form.Option id={`S${medhistory.value}`} value={Form.Json.Get(medHistory, `S${medhistory.value}`)} optionValues={yesNoOptions} size={[MedWidth.status]} onChange={(e) => Form.Json.Set(e, setMedHistory)}  />
                                    <Control.Form.Text id={`R${medhistory.value}`} value={Form.Json.Get(medHistory, `R${medhistory.value}`)} size={[MedWidth.Comment]} onChange={(e) => Form.Json.Set(e, setMedHistory)}  />
                                  </Control.Form.Item>
                                </Control.Form.Index>
                              )})}
                            </Control.Form.List>
                          </Control.Form.Table>
                        </Control.Box>
                      </Control.Container>
                    </Control.Box>
                    <Control.Box>
                      <Control.Flex>
                        <Control.Column size={[0,50,2,1]}>
                          <Control.Container>
                            <Field.ContainerTitle title='Family Physician Information' />
                            <Control.Box>
                              <Field.Text id={CMF.Physician.Name} value={Utility.Get.FieldValue(clientData, CMF.Physician.Name as keyof ClientDataColumn)} title="Physician Name" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                              <Field.Text id={CMF.Physician.Phone} value={Utility.Format.Phone(Utility.Get.FieldValue(clientData, CMF.Physician.Phone as keyof ClientDataColumn))} title="Phone" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} maxLength={16} />
                              <Field.Text id={CMF.Physician.Fax} value={Utility.Format.Phone(Utility.Get.FieldValue(clientData, CMF.Physician.Fax as keyof ClientDataColumn))} title="Fax" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} maxLength={16} />
                              <Field.Text id={CMF.Physician.ClinicName} value={Utility.Get.FieldValue(clientData, CMF.Physician.ClinicName as keyof ClientDataColumn)} title="Clinic Name" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                            </Control.Box>
                          </Control.Container>
                          <Control.Container>
                            <Field.ContainerTitle title='Emergency Information' />
                            <Control.Box>
                              <Field.Text id={CMF.Emergency.ContactName} value={Utility.Get.FieldValue(clientData, CMF.Emergency.ContactName as keyof ClientDataColumn)} title="Contact Name" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                              <Field.Text id={CMF.Emergency.Relation} value={Utility.Get.FieldValue(clientData, CMF.Emergency.Relation as keyof ClientDataColumn)} title="Relation" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                              <Field.Text id={CMF.Emergency.Phone} value={Utility.Get.FieldValue(clientData, CMF.Emergency.Phone as keyof ClientDataColumn)} title="Phone/Cell" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                            </Control.Box>
                          </Control.Container>
                        </Control.Column>
                        <Control.Column size={[2,50,0,2]}>
                          <Control.Container>
                            <Field.ContainerTitle title='Family History' />
                            <Control.Box>
                              <Field.Area id={CMF.Family.FatherHistory} value={Utility.Get.FieldValue(clientData, CMF.Family.FatherHistory as keyof ClientDataColumn)} title="Father History" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                              <Field.Area id={CMF.Family.MotherHistory} value={Utility.Get.FieldValue(clientData, CMF.Family.MotherHistory as keyof ClientDataColumn)} title="Mother History" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true}  />
                              <Field.Area id={CMF.Family.BrotherHistory} value={Utility.Get.FieldValue(clientData, CMF.Family.BrotherHistory as keyof ClientDataColumn)} title="Brother History" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                              <Field.Area id={CMF.Family.SisterHistory} value={Utility.Get.FieldValue(clientData, CMF.Family.SisterHistory as keyof ClientDataColumn)} title="Sister History" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)}  horizontal={true} />
                            </Control.Box>
                          </Control.Container>
                        </Control.Column>
                      </Control.Flex>
                    </Control.Box>
                  </Control.Column>
                  <Control.Column size={[2,30,0,2]}>
                    <Control.Container>
                      <Field.ContainerTitle title='Other Details' />
                      <Control.Box>
                        <Field.Text id={CMF.HearingAid.MakeModel} value={Utility.Get.FieldValue(clientData, CMF.HearingAid.MakeModel as keyof ClientDataColumn)} title="Make/Model" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                        <Field.Text id={CMF.HearingAid.LeftSNo} value={Utility.Get.FieldValue(clientData, CMF.HearingAid.LeftSNo as keyof ClientDataColumn)} title="Left SNo." onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                        <Field.Text id={CMF.HearingAid.RightSNo} value={Utility.Get.FieldValue(clientData, CMF.HearingAid.RightSNo as keyof ClientDataColumn)} title="Right SNo." onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                        <Field.Text id={CMF.HearingAid.Remote} value={Utility.Get.FieldValue(clientData, CMF.HearingAid.Remote as keyof ClientDataColumn)} title="Remote" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                        <Field.Text id={CMF.HearingAid.Charger} value={Utility.Get.FieldValue(clientData, CMF.HearingAid.Charger as keyof ClientDataColumn)} title="Charger" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                        <Field.Text id={CMF.HearingAid.Battery} value={Utility.Get.FieldValue(clientData, CMF.HearingAid.Battery as keyof ClientDataColumn)} title="Battery" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                        <Field.Text id={CMF.HearingAid.Receiver} value={Utility.Get.FieldValue(clientData, CMF.HearingAid.Receiver as keyof ClientDataColumn)} title="Receivers" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                        <Field.Text id={CMF.HearingAid.Domes} value={Utility.Get.FieldValue(clientData, CMF.HearingAid.Domes as keyof ClientDataColumn)} title="Domes/Earmolds" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                        <Field.Text id={CMF.HearingAid.Waxguards} value={Utility.Get.FieldValue(clientData, CMF.HearingAid.Waxguards as keyof ClientDataColumn)} title="Wax guards" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                        <Field.Date id={CMF.HearingAid.FitDate} value={Utility.Get.FieldValue(clientData, CMF.HearingAid.FitDate as keyof ClientDataColumn)} title="Fit Date" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                        <Field.Date id={CMF.HearingAid.Warranty} value={Utility.Get.FieldValue(clientData, CMF.HearingAid.Warranty as keyof ClientDataColumn)} title="Warranty" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                        <Field.Date id={CMF.HearingAid.LossDamage} value={Utility.Get.FieldValue(clientData, CMF.HearingAid.LossDamage as keyof ClientDataColumn)} title="Loss + Damage" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} horizontal={true} />
                        <Field.Area id={CMF.HearingAid.Info} value={Utility.Get.FieldValue(clientData, CMF.HearingAid.Info as keyof ClientDataColumn)} title="Add. Information" onChange={(e) => Form.MultiValue.Change(e, clientData, setClientData)} titleClass='pl0' height={348} />
                      </Control.Box>
                    </Control.Container>
                  </Control.Column>
                </Control.Flex>
              </Control.Row>
            </Control.Tab.Content>
            
            <Control.Tab.Content title='Appointment' id={Code.Tab.Tab3} isActive={activeTab === Code.Tab.Tab3}>
              <Button.Create keyId={keyId} title={Code.Form.Name.APPOINTMENT} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.APPOINTMENT, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivAppointment} />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.Type, appointmentWidth.type],
                    [Title.Date, appointmentWidth.date],
                    [Title.Start, appointmentWidth.start], 
                    [Title.End, appointmentWidth.end],
                    [Title.Doctor, appointmentWidth.doctor],
                    [Title.Status, appointmentWidth.status],
                    [Title.PostCheck, appointmentWidth.postcheck],
                    [Title.CreatedBy, appointmentWidth.createdby],
                    [Title.Comment, appointmentWidth.comment],
                  ]} first={1} />
                </Control.Form.Title>
                <Control.Form.List>
                  {appointmentData.map((appointment, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Grid.Modify path={Utility.Join.Edit(PrivAppointment, Code.Form.Name.APPOINTMENT, appointment.appointment_id)} iframeRef={iframeRef} Privilege={PrivAppointment} />
                        <Control.Grid.Items values={[
                          [appointment.type_name, appointmentWidth.type],
                          [Utility.Format.DateOnly(appointment.appointment_start_date), appointmentWidth.date],
                          [Utility.Format.Time(appointment.appointment_start_time), appointmentWidth.start],
                          [Utility.Format.Time(appointment.appointment_end_time), appointmentWidth.end],
                          [Utility.Get.FullName(appointment,Code.Form.Name.DOCTOR), appointmentWidth.doctor],
                          [appointment.status_name, appointmentWidth.status],
                          [appointment.postcheck_name, appointmentWidth.postcheck],
                          [Utility.Get.FullName(appointment,Code.Form.Name.USER), appointmentWidth.createdby],
                          [appointment.appointment_comment, appointmentWidth.comment],
                        ]} />
                      </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>

            <Control.Tab.Content title='Exam' id={Code.Tab.Tab4} isActive={activeTab === Code.Tab.Tab4}>
              <Button.Create title={Code.Form.Name.EXAM} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.EXAM, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivExam} />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.Date, examWidth.date],
                    [Title.Type, examWidth.type], 
                    [Title.Doctor, examWidth.doctor],
                    [Title.State, examWidth.status],
                    [Title.CreatedBy, examWidth.createdby],
                    [Title.Comment, examWidth.note],
                  ]} first={4} />
                </Control.Form.Title>
                <Control.Form.List>
                  {examData.map((exam, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Form.Print path={`${Utility.Join.Print(Privilege, Code.Form.Name.EXAM, exam.exam_id)}?data=1`} iframeRef={iframeRef} Privilege={PrivExam} />
                        <Control.Grid.Double path={`exam/${exam.exam_id}?data=1`} path2={`compare/${exam.exam_id}?data=1`} iframeRef={iframeRef} iframeRef2={iframeRef2} Privilege={Privilege} title='Open first exam' />
                        <Control.Grid.Double path={`exam/${exam.exam_id}?data=2`} path2={`compare/${exam.exam_id}?data=2`} iframeRef={iframeRef} iframeRef2={iframeRef2} Privilege={Privilege} title='Open second exam' icon={`num2 noicon${exam.exam_data2?.length}`} />
                        <Control.Grid.Double path={`exam/${exam.exam_id}?data=2`} path2={`compare/${exam.exam_id}?data=2`} iframeRef={iframeRef} iframeRef2={iframeRef2} Privilege={Privilege} title='Open third exam' icon={`num3 noicon${exam.exam_data3?.length}`} />
                        <Control.Grid.Items values={[
                          [Utility.Format.DateOnly(exam.exam_date), examWidth.date],
                          [exam.examtype_name, examWidth.type],
                          [exam.doctor_first_name, examWidth.doctor],
                          [exam.status_name, examWidth.status],
                          [exam.user_first_name, appointmentWidth.createdby],
                          [exam.exam_comment, examWidth.note],
                        ]} />
                      </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>

            <Control.Tab.Content title='Sale' id={Code.Tab.Tab5} isActive={activeTab === Code.Tab.Tab5}>
              <Button.Create title={Code.Form.Name.SALE} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.SALE, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivOrders} />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                  [Title.Date, saleWidth.date],
                  [Title.SNo, saleWidth.sno], 
                  [Title.Desc, saleWidth.desc],
                  [Title.CreatedBy, saleWidth.createdby],
                  ]} first={2} />
                </Control.Form.Title>
                <Control.Form.List>
                  {saleData.map((sale, index) => { return (
                  <Control.Form.Index key={index} index={index}>
                    <Control.Form.Item>
                    <Control.Form.Edit path={Utility.Join.Edit(PrivSale, Code.Form.Name.SALE, sale.sale_id)} iframeRef={iframeRef} Privilege={PrivSale} />
                    <Control.Form.Print path={Utility.Join.Print(PrivSale, Code.Form.Name.SALE, sale.sale_id)} iframeRef={iframeRef} Privilege={PrivSale} />
                    <Control.Grid.Items values={[
                      [Utility.Format.DateOnly(sale.sale_date), saleWidth.date],
                      [sale.sale_number, saleWidth.sno],
                    ]} />
                    <Control.Grid.SaleLink data={sale.saleorder_data} width={saleWidth.desc}  iframeRef={iframeRef} />
                    <Control.Grid.Items values={[
                      [sale.user_first_name, saleWidth.createdby],
                    ]} />
                    </Control.Form.Item>
                  </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>


            <Control.Tab.Content title='Order' id={Code.Tab.Tab6} isActive={activeTab === Code.Tab.Tab6}>
              <Button.Create title={Code.Form.Name.ORDERS} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.ORDERS, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivOrders} />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                  [Title.Date, ordersWidth.date],
                  [Title.OrdersNo, ordersWidth.sno], 
                  [Title.Insurer, ordersWidth.insurer],
                  [Title.Segment, ordersWidth.segment],
                  [Title.Amount, ordersWidth.net, Code.Align.RIGHT],
                  [Title.Received, ordersWidth.received, Code.Align.RIGHT],
                  [Title.Balance, ordersWidth.balance, Code.Align.RIGHT],
                  [Title.State, ordersWidth.status],
                  [Title.CreatedBy, ordersWidth.createdby],
                  ]} first={3} />
                </Control.Form.Title>
                <Control.Form.List>
                  {ordersData.map((orders, index) => { return (
                  <Control.Form.Index key={index} index={index}>
                    <Control.Form.Item>
                    <Control.Form.Edit path={Utility.Join.Edit(PrivOrders, Code.Form.Name.ORDERS, orders.orders_id)} iframeRef={iframeRef} Privilege={PrivOrders} />
                    <Control.Form.Print path={Utility.Join.Print(PrivOrders, Code.Form.Name.ORDERS, orders.orders_id)} iframeRef={iframeRef} Privilege={PrivOrders} />
                    <Control.Form.Sale path={Utility.Join.Edit(PrivOrders, Code.Form.Name.SALE, orders.sale_id)} iframeRef={iframeRef} Privilege={PrivSale} />
                    <Control.Grid.Items values={[
                      [Utility.Format.DateOnly(orders.orders_date), ordersWidth.date],
                      [orders.orders_number, ordersWidth.sno],
                      [orders.insurer1_name, ordersWidth.insurer],
                      [orders.segment_name, ordersWidth.segment],
                      [Utility.Format.Amount(orders.orders_net_amount), ordersWidth.net, Code.Align.RIGHT],
                      [Utility.Format.Amount(orders.orders_net_amount), ordersWidth.received, Code.Align.RIGHT],
                      [Utility.Format.Amount(orders.orders_net_amount), ordersWidth.balance, Code.Align.RIGHT],
                      [orders.status_name, ordersWidth.status],
                      [orders.user_first_name, appointmentWidth.createdby],
                    ]} />
                    </Control.Form.Item>
                  </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>

            <Control.Tab.Content title='Invoice' id={Code.Tab.Tab7} isActive={activeTab === Code.Tab.Tab7}>
              <Button.Create title={Code.Form.Name.INVOICE} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.INVOICE, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivInvoice} />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.Date, invoiceWidth.date],
                    [Title.InvoiceNo, invoiceWidth.sno], 
                    [Title.Insurer, invoiceWidth.insurer],
                    [Title.Segment, invoiceWidth.segment],
                    [Title.Billed, invoiceWidth.net, Code.Align.RIGHT],
                    [Title.Received, invoiceWidth.received, Code.Align.RIGHT],
                    [Title.Balance, invoiceWidth.balance, Code.Align.RIGHT],
                    [Title.State, invoiceWidth.status],
                    [Title.CreatedBy, invoiceWidth.createdby],
                  ]} first={3} />
                </Control.Form.Title>
                <Control.Form.List>
                  {invoiceData.map((invoice, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Form.Edit path={Utility.Join.Edit(PrivInvoice, Code.Form.Name.INVOICE, invoice.invoice_id)} iframeRef={iframeRef} Privilege={PrivInvoice} />
                        <Control.Form.Print path={Utility.Join.Print(PrivInvoice, Code.Form.Name.INVOICE, invoice.invoice_id)} iframeRef={iframeRef} Privilege={PrivInvoice} />
                        <Control.Form.Sale path={Utility.Join.Edit(PrivInvoice, Code.Form.Name.SALE, invoice.sale_id)} iframeRef={iframeRef} Privilege={PrivSale} />
                        <Control.Grid.Items values={[
                          [Utility.Format.DateOnly(invoice.invoice_date), invoiceWidth.date],
                          [invoice.invoice_number, invoiceWidth.sno],
                          [invoice.insurer1_name, invoiceWidth.insurer],
                          [invoice.segment_name, invoiceWidth.segment],
                          [Utility.Format.Amount(invoice.invoice_net_amount), invoiceWidth.net, Code.Align.RIGHT],
                          ["--", invoiceWidth.received, Code.Align.RIGHT],
                          ["--", invoiceWidth.balance, Code.Align.RIGHT],
                          [invoice.status_name, invoiceWidth.status],
                          [invoice.user_first_name, appointmentWidth.createdby],
                        ]} />
                      </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>

            <Control.Tab.Content title='Proforma' id={Code.Tab.Tab8} isActive={activeTab === Code.Tab.Tab8}>
              <Button.Create title={Code.Form.Name.PROFORMA} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.PROFORMA, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivProforma} />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.Date, proformaWidth.date],
                    [Title.BillNo, proformaWidth.sno], 
                    [Title.Comment, proformaWidth.Comment],
                    [Title.Amount, proformaWidth.net, Code.Align.RIGHT],
                    [Title.Segment, proformaWidth.segment],
                    [Title.State, proformaWidth.status],
                    [Title.CreatedBy, proformaWidth.createdby],
                  ]} first={3} />
                </Control.Form.Title>
                <Control.Form.List>
                  {proformaData.map((proforma, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Form.Edit path={Utility.Join.Edit(PrivProforma, Code.Form.Name.PROFORMA, proforma.proforma_id)} iframeRef={iframeRef} Privilege={PrivProforma} />
                        <Control.Form.Print path={Utility.Join.Print(PrivProforma, Code.Form.Name.PROFORMA, proforma.proforma_id)} iframeRef={iframeRef} Privilege={PrivProforma} />
                        <Control.Form.Sale path={Utility.Join.Edit(PrivProforma, Code.Form.Name.SALE, proforma.sale_id)} iframeRef={iframeRef} Privilege={PrivSale} />
                        <Control.Grid.Items values={[
                          [Utility.Format.DateOnly(proforma.proforma_date), proformaWidth.date],
                          [proforma.proforma_number, proformaWidth.sno],
                          [proforma.proforma_comment, proformaWidth.Comment],
                          [Utility.Format.Amount(proforma.proforma_net_amount), proformaWidth.net, Code.Align.RIGHT],
                          [proforma.segment_name, proformaWidth.segment],
                          [proforma.status_name, proformaWidth.status],
                          [proforma.user_first_name, proformaWidth.createdby],
                        ]} />
                     </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>

            <Control.Tab.Content title='Dispense' id={Code.Tab.Tab9} isActive={activeTab === Code.Tab.Tab9}>
              <Button.Create title={Code.Form.Name.DISPENSE} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.DISPENSE, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivDispense} />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.Date, dispenseWidth.date],
                    [Title.DispenseNo, dispenseWidth.sno], 
                    [Title.Comment, dispenseWidth.Comment],
                    [Title.Amount, dispenseWidth.net, Code.Align.RIGHT],
                    [Title.Segment, dispenseWidth.segment],
                    [Title.State, dispenseWidth.status],
                    [Title.CreatedBy, dispenseWidth.createdby],
                  ]} first={2} />
                </Control.Form.Title>
                <Control.Form.List>
                  {dispenseData.map((dispense, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Form.Edit path={Utility.Join.Edit(PrivDispense, Code.Form.Name.DISPENSE, dispense.dispense_id)} iframeRef={iframeRef} Privilege={PrivDispense} />
                        <Control.Form.Print path={Utility.Join.Print(PrivDispense, Code.Form.Name.DISPENSE, dispense.dispense_id)} iframeRef={iframeRef} Privilege={PrivDispense} />
                        <Control.Grid.Items values={[
                          [Utility.Format.DateOnly(dispense.dispense_date), dispenseWidth.date],
                          [dispense.dispense_number, dispenseWidth.sno],
                          [dispense.dispense_comment, dispenseWidth.Comment],
                          [Utility.Format.Amount(dispense.dispense_net_amount), dispenseWidth.net, Code.Align.RIGHT],
                          [dispense.segment_name, dispenseWidth.segment],
                          [dispense.status_name, dispenseWidth.status],
                          [dispense.user_first_name, dispenseWidth.createdby],
                        ]} />
                     </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>

            <Control.Tab.Content title='Estimate' id={Code.Tab.Tab10} isActive={activeTab === Code.Tab.Tab10}>
              <Button.Create title={Code.Form.Name.ESTIMATE} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.ESTIMATE, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivEstimate} />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.Date, estimateWidth.date],
                    [Title.EstimateNo, estimateWidth.sno], 
                    [Title.Comment, estimateWidth.Comment],
                    [Title.Amount, estimateWidth.net, Code.Align.RIGHT],
                    [Title.Segment, estimateWidth.segment],
                    [Title.State, estimateWidth.status],
                    [Title.CreatedBy, estimateWidth.createdby],
                  ]} first={2} />
                </Control.Form.Title>
                <Control.Form.List>
                  {estimateData.map((estimate, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Form.Edit path={Utility.Join.Edit(Privilege, Code.Form.Name.ESTIMATE, estimate.estimate_id)} iframeRef={iframeRef} Privilege={PrivEstimate} />
                        <Control.Form.Print path={Utility.Join.Print(Privilege, Code.Form.Name.ESTIMATE, estimate.estimate_id)} iframeRef={iframeRef} Privilege={PrivEstimate} />
                        <Control.Grid.Items values={[
                          [Utility.Format.DateOnly(estimate.estimate_date), estimateWidth.date],
                          [estimate.estimate_number, estimateWidth.sno],
                          [estimate.estimate_comment, estimateWidth.Comment],
                          [Utility.Format.Amount(estimate.estimate_net_amount), estimateWidth.net, Code.Align.RIGHT],
                          [estimate.segment_name, estimateWidth.segment],
                          [estimate.status_name, estimateWidth.status],
                          [estimate.user_first_name, estimateWidth.createdby],
                        ]} />
                      </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>
           
            <Control.Tab.Content title='Insurance' id={Code.Tab.Tab11} isActive={activeTab === Code.Tab.Tab11}>
              <Button.Create title={Code.Form.Name.INSURANCE} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.INSURANCE, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivInsurance} />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.PolicyNumber, insuranceWidth.policy], 
                    [Title.MemberNumber, insuranceWidth.member],
                    [Title.GroupNumber, insuranceWidth.group],
                    [Title.Insurer, insuranceWidth.insurer],
                    [Title.Comment, insuranceWidth.comment],
                  ]} first={1} />
                </Control.Form.Title>
                <Control.Form.List>
                  {insuranceData.map((insurance, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Form.Edit path={Utility.Join.Edit(PrivInsurance, Code.Form.Name.INSURANCE, insurance.insurance_id)} iframeRef={iframeRef} Privilege={PrivInsurance} />
                        <Control.Grid.Items values={[
                          [insurance.insurance_policy_number, insuranceWidth.policy],
                          [insurance.insurance_member_number, insuranceWidth.member],
                          [insurance.insurance_group_number, insuranceWidth.group],
                          [insurance.insurer_name, insuranceWidth.insurer],
                          [insurance.insurance_comment, insuranceWidth.comment],
                        ]} />
                      </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>

            <Control.Tab.Content title='Project' id={Code.Tab.Tab12} isActive={activeTab === Code.Tab.Tab12}>
            <Button.Create title={Code.Form.Name.PROJECT} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.PROJECT, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivProject} />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.Date, projectWidth.date],
                    [Title.SNo, projectWidth.sno], 
                    [Title.Comment, projectWidth.Comment],
                    [Title.Type, projectWidth.type],
                    [Title.State, projectWidth.status],
                    [Title.CreatedBy, projectWidth.createdby],
                  ]} first={1} />
                </Control.Form.Title>
                <Control.Form.List>
                  {projectData.map((project, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Form.Edit path={Utility.Join.Edit(PrivProject, Code.Form.Name.PROJECT, project.project_id)} iframeRef={iframeRef} Privilege={PrivProject} />
                        <Control.Grid.Items values={[
                          [Utility.Format.DateOnly(project.project_date), projectWidth.date],
                          [project.project_number, projectWidth.sno],
                          [project.project_comment, projectWidth.Comment],
                          [project.type_name, projectWidth.type],
                          [project.status_name, projectWidth.status],
                          [project.user_first_name, projectWidth.createdby],
                        ]} />
                     </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>

            <Control.Tab.Content title='Notes' id={Code.Tab.Tab13} isActive={activeTab === Code.Tab.Tab13}>
              <Button.Create title={Code.Form.Name.NOTE} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.NOTE, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivNote} />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.Date, noteWidth.date],
                    [Title.Comment, noteWidth.Comment],
                    [Title.Type, noteWidth.type],
                    [Title.State, noteWidth.status],
                    [Title.CreatedBy, noteWidth.createdby],
                  ]} first={1} />
                </Control.Form.Title>
                <Control.Form.List>
                  {noteData.map((note, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Form.Edit path={Utility.Join.Edit(PrivNote, Code.Form.Name.NOTE, note.note_id)} iframeRef={iframeRef} Privilege={PrivNote} />
                        <Control.Grid.Items values={[
                          [Utility.Format.DateOnly(note.note_date), noteWidth.date],
                          [note.note_comment, noteWidth.Comment],
                          [note.type_name, noteWidth.type],
                          [note.status_name, noteWidth.status],
                          [note.user_first_name, noteWidth.createdby],
                        ]} />
                     </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>

            <Control.Tab.Content title='Recall' id={Code.Tab.Tab14} isActive={activeTab === Code.Tab.Tab14}>
              <Button.Create title={Code.Form.Name.RECALL} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.RECALL, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivRecall} />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.Type, recallWidth.type],
                    [Title.Comment, recallWidth.Comment],
                    [Title.Date, recallWidth.date],
                    [Title.Segment, recallWidth.segment],
                    [Title.State, recallWidth.status],
                    [Title.CreatedBy, recallWidth.createdby],
                  ]} first={1} />
                </Control.Form.Title>
                <Control.Form.List>
                  {recallData.map((recall, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Form.Edit path={Utility.Join.Edit(PrivRecall, Code.Form.Name.RECALL, recall.recall_id)} iframeRef={iframeRef} Privilege={PrivRecall} />
                        <Control.Grid.Items values={[
                          [recall.type_name, recallWidth.type],
                          [recall.recall_comment, recallWidth.Comment],
                          [Utility.Format.DateOnly(recall.recall_date), recallWidth.date],
                          [recall.segment_name, recallWidth.segment],
                          [recall.status_name, recallWidth.status],
                          [recall.user_first_name, recallWidth.createdby],
                        ]} />
                     </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>

            <Control.Tab.Content title='Referral' id={Code.Tab.Tab15} isActive={activeTab === Code.Tab.Tab15}>
              <Button.Create title={Code.Form.Name.REFERRAL} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.REFERRAL, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivReferral} />
                <Control.Form.Table>
                  <Control.Form.Title>
                    <Control.Form.Columns values={[
                    [Title.Date, referralWidth.date],
                    [Title.Title, referralWidth.Name],
                    [Title.Doctor, referralWidth.doctor],
                    [Title.RecDoctor, referralWidth.recdoctor],
                    [Title.CreatedBy, referralWidth.createdby],
                    ]} first={1} />
                  </Control.Form.Title>
                  <Control.Form.List>
                    {referralData.map((referral, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                      <Control.Form.Edit path={Utility.Join.Edit(PrivReferral, Code.Form.Name.REFERRAL, referral.referral_id)} iframeRef={iframeRef} Privilege={PrivReferral} />
                      <Control.Form.Print path={Utility.Join.Print(PrivReferral, Code.Form.Name.REFERRAL, referral.referral_id)} iframeRef={iframeRef} Privilege={PrivReferral} />
                      <Control.Grid.Items values={[
                        [Utility.Format.DateOnly(referral.referral_date), referralWidth.date],
                        [referral.referral_name, referralWidth.Name],
                        [Utility.Get.FullName(referral,Code.Form.Name.DOCTOR), referralWidth.doctor],
                        [Utility.Get.FullName(referral,Code.Form.Name.RECDOCTOR), referralWidth.recdoctor],
                        [referral.user_first_name, referralWidth.createdby],
                      ]} />
                    </Control.Form.Item>
                    </Control.Form.Index>
                    )})}
                  </Control.Form.List>
                  </Control.Form.Table>
            </Control.Tab.Content>

            <Control.Tab.Content title='Billing' id={Code.Tab.Tab16} isActive={activeTab === Code.Tab.Tab16}>
              <Button.Create title={Code.Form.Name.BILLING} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.BILLING, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivBilling} />
              <Button.Create title={"Multiple"} onClick={() => Form.Show.Popup(iframeRef, "multibilling", Code.UrlPara.Client, formData.client_id)}  Privilege={PrivBilling} className='ml2' />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.SNo, billingWidth.sno],
                    [Title.Amount, billingWidth.amount, Code.Align.RIGHT], 
                    [Title.Paid, billingWidth.paid, Code.Align.RIGHT],
                    [Title.HSC, billingWidth.hsc], 
                    [Title.Diag, billingWidth.diag],
                    [Title.State, billingWidth.status], 
                    [Title.Doctor, billingWidth.doctor], 
                    [Title.GovKey, billingWidth.govtkey],
                    [Title.Billed, billingWidth.billdate],
                    [Title.Claimed, billingWidth.claimdate],
                    [Title.Remittance, billingWidth.remittancedate],
                  ]} first={1} />
                </Control.Form.Title>
                <Control.Form.List>
                  {billingData.map((billing, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Form.Edit path={Utility.Join.Edit(PrivBilling, Code.Form.Name.BILLING, billing.billing_id)} iframeRef={iframeRef} Privilege={PrivBilling} />
                        <Control.Grid.Items values={[
                          [billing.billing_number, billingWidth.sno],
                          [Utility.Format.Amount(billing.billing_amount), billingWidth.amount, Code.Align.RIGHT],
                          [Utility.Format.Amount(billing.billing_insurance_amount), billingWidth.paid, Code.Align.RIGHT],
                          [billing.billing_hsc_name, billingWidth.hsc],
                          [billing.billing_diagnosis1_name, billingWidth.diag],
                          [billing.status_name, billingWidth.status],
                          [billing.doctor_first_name, billingWidth.doctor],
                          [billing.billing_govkey, billingWidth.govtkey],
                          [Utility.Format.DateOnly(billing.billing_date), billingWidth.billdate],
                          [Utility.Format.DateOnly(billing.claim_date), billingWidth.claimdate],
                          [Utility.Format.DateOnly(billing.remittance_date), billingWidth.remittancedate],
                        ]} />
                     </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>

            <Control.Tab.Content title='Document' id={Code.Tab.Tab17} isActive={activeTab === Code.Tab.Tab17}>
              <Button.Create title={Code.Form.Name.DOCUMENT} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.DOCUMENT, Code.UrlPara.Client, formData.client_id)}  Privilege={PrivDocument} />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.Date, documentWidth.date],
                    [Title.Type, documentWidth.type],
                    [Title.Comment, documentWidth.Comment], 
                    [Title.FileNo, documentWidth.fileno],
                    [Title.CreatedBy, documentWidth.createdby],
                  ]} first={2} />
                </Control.Form.Title>
                <Control.Form.List>
                  {documentData.map((document, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Form.Edit path={Utility.Join.Edit(PrivDocument, Code.Form.Name.DOCUMENT, document.document_id)} iframeRef={iframeRef} Privilege={PrivDocument} />
                        <Control.Form.Print path={Utility.Join.Print(PrivDocument, Code.Form.Name.DOCUMENT, document.document_id)} iframeRef={iframeRef} Privilege={PrivDocument} />
                        <Control.Grid.Items values={[
                          [Utility.Format.DateOnly(document.document_date), documentWidth.date],
                          [document.type_name, documentWidth.type],
                          [document.document_comment, documentWidth.Comment],
                          [document.document_file_no, documentWidth.fileno],
                          [document.user_first_name, documentWidth.createdby],
                        ]} />
                     </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>

          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={() => window.location.reload()} />
      <Control.FormPopup2 iframeRef={iframeRef2} onRefresh={() => window.location.reload()} />
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default ClientForm;